import {createSelector} from 'reselect';
import {AppState} from '../../index';

export const activeCertificatesSelector = () =>
  createSelector(
    (state: AppState) => state.eCertificates.active,
    (items) => items,
  );

export const certificatesHistorySelector = () =>
  createSelector(
    (state: AppState) => state.eCertificates.history,
    (items) => items,
  );

export const certificateInfoSelector = () =>
  createSelector(
    (state: AppState) => state.eCertificates.certificateInfo,
    (item) => item,
  );

export const sellersSelector = () =>
  createSelector(
    (state: AppState) => state.eCertificates.sellers,
    (items) => items,
  );

export const departmentSelector = () =>
  createSelector(
    (state: AppState) => state.eCertificates.department,
    (item) => item,
  );

export const certifacteDownloadingSelector = () =>
  createSelector(
    (state: AppState) => state.eCertificates.downloading,
    (state) => state,
  );
